import { DecisionStatusType } from 'Types/Tasks.types'
import { TaskMode } from 'Types/Tasks.types'
import { ActionConfig, ActionContext, IAction } from '../Action'

export class SubmitQCAction implements IAction {
    static Id = 'SubmitQC' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench(): void {
        this.actionContext.workbenchUiAccessor.toolbar.addAction(
            {
                id: 'submit-qc',
                title: this.config?.title ?? 'Submit',
                type: 'button',
                disabled: this.config?.disabled ?? false,
                onClick:
                    this.config?.onClick ??
                    (async () => {
                        const errors =
                            this.actionContext.studio.inputManager.getViolationCount('error')
                        if (errors) {
                            this.actionContext.modalManager?.showModal('violations-modal')
                            this.actionContext.task.ui?.updater.forceUpdate()
                            return
                        }
                        this.actionContext.task.taskState.setDecision({
                            status: DecisionStatusType.ACCEPT,
                            schema_version: 1,
                        })
                        this.actionContext.modalManager?.setModalMetaData('submit-modal', {
                            taskMode: TaskMode.QC,
                            isAccept: true,
                        })
                        this.actionContext.modalManager?.showModal('submit-modal')
                    }),
                color: 'primary',
                tooltip: this.config?.tooltip,
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor.toolbar.removeAction('submit-qc')
    }
}
